export const translations = {
    en: {
        nav: {
            home: "Home", about: "About", services: "Services", booking: "Book Now",
            track: "Track", gallery: "Gallery", contact: "Contact", login: "Customer Login",
            adminLogin: "Admin", dashboard: "Dashboard", logout: "Logout", register: "Register",
            forms: "Forms", news: "News",
        },
        hero: {
            tagline: "Trusted since day one",
            title1: "Government &",
            title2: "Digital Services",
            title3: "made effortless",
            desc: "Sri Matha Multiservices is your authorized MeeSeva & multi-service center in Mahabubnagar — Aadhaar, PAN, passport, certificates, payments and much more, all under one trusted roof.",
            cta1: "Book a Service",
            cta2: "Track Application",
            stat1: "21+ Services",
            stat2: "5000+ Customers",
            stat3: "MeeSeva Authorized",
        },
        home: {
            servicesTitle: "Everything you need, in one visit",
            servicesDesc: "From essential government IDs to daily utility payments — we handle it all with care, speed and transparency.",
            viewAll: "View all services",
            whyTitle: "Why Sri Matha?",
            whyDesc: "A trusted local name backed by professional systems.",
            f1t: "Authorized Center",
            f1d: "Official MeeSeva franchise with certified digital services.",
            f2t: "Fast Turnaround",
            f2d: "Trained staff and streamlined workflows for quicker processing.",
            f3t: "Track Anytime",
            f3d: "Get a reference number & monitor your application 24×7 online.",
            f4t: "Secure & Private",
            f4d: "Your documents are handled with strict confidentiality.",
            ctaTitle: "Ready to get started?",
            ctaDesc: "Book your service online in under a minute.",
            newsTitle: "Latest updates",
            newsDesc: "Stay informed on new schemes, rules and service changes.",
            viewAllNews: "View all news",
        },
        about: {
            title: "About Sri Matha Multiservices",
            lead: "Serving Mahabubnagar with authorized MeeSeva & multi-service solutions.",
            body1: "For years, Sri Matha Multiservices has been a trusted destination for citizens seeking government documentation, digital payments, and daily-life services. Located conveniently on MBNR Main Road near IOCL Petrol Pump, Janampeta — we combine professional systems with local, personal service.",
            body2: "Whether you need a new Aadhaar update, PAN card, driving licence assistance, or the fastest bill payment in town, our team is trained to guide you at every step. We also offer specialized embroidery services for your tailoring needs.",
            mission: "Our Mission",
            missionDesc: "Bring reliable, transparent government & digital services closer to every citizen of Mahabubnagar.",
            values: "Our Values",
            v1: "Trust", v2: "Speed", v3: "Transparency", v4: "Care",
        },
        services: {
            title: "Our Services",
            desc: "Explore all services we offer. Click any to book instantly.",
            searchPh: "Search a service…",
            book: "Book Now",
        },
        booking: {
            title: "Online Booking",
            desc: "Fill in the form below. You'll get a reference number to track your application.",
            step1: "Select Service",
            step2: "Your Details",
            step3: "Documents",
            step4: "Review & Submit",
            service: "Service", fullName: "Full Name", phone: "Phone", email: "Email",
            address: "Address", notes: "Notes / Requirements",
            uploadTitle: "Upload documents (optional)",
            uploadDesc: "PDF, JPG, PNG up to 8 MB each.",
            submit: "Submit Booking",
            next: "Continue",
            back: "Back",
            success: "Booking submitted successfully!",
            reference: "Your Reference Number",
        },
        track: {
            title: "Track your Application",
            desc: "Enter your reference number to see live status.",
            placeholder: "e.g. SMM250219ABC12",
            track: "Track",
            status: "Status",
            notFound: "No application found with this reference.",
        },
        gallery: {
            title: "Gallery",
            desc: "Glimpses of our center and services.",
        },
        news: {
            chip: "News & Updates",
            title: "Latest News & Announcements",
            desc: "Government notices, MeeSeva updates and service alerts — curated to keep you informed.",
            empty: "No news yet. Please check back soon.",
            readMore: "Read more",
        },
        forms: {
            chip: "Application Forms",
            title: "Download Application Forms",
            desc: "Official government forms for common services. Download, fill offline, and bring to our center — we help you complete the rest.",
            searchPh: "Search a form…",
            download: "Download",
            needHelpTitle: "Not sure which form you need?",
            needHelpDesc: "Send us a message on WhatsApp — our team will guide you.",
        },
        contact: {
            title: "Contact Us",
            desc: "We're here to help. Drop us a message or visit our center.",
            name: "Name", email: "Email", phone: "Phone", subject: "Subject", message: "Message",
            send: "Send Message",
            sent: "Message sent! We'll reach out shortly.",
            visit: "Visit Us", call: "Call Us", write: "Write to Us", hours: "Working Hours",
            hoursValue: "Mon – Sat: 9:00 AM – 8:30 PM\nSun: 10:00 AM – 2:00 PM",
        },
        auth: {
            loginTitle: "Welcome back",
            loginDesc: "Login to track your applications and manage bookings.",
            registerTitle: "Create your account",
            registerDesc: "Register for free — track applications and get updates.",
            adminTitle: "Admin Login",
            adminDesc: "Restricted area. Admin only.",
            emailPh: "Email address",
            passwordPh: "Password",
            namePh: "Full name",
            phonePh: "Phone number",
            login: "Login",
            register: "Register",
            switchToRegister: "New here? Create account",
            switchToLogin: "Already have an account? Login",
            or: "or",
        },
        dashboard: {
            welcome: "Welcome",
            myBookings: "My Bookings",
            noBookings: "You have no bookings yet.",
            bookNow: "Book a service",
        },
        admin: {
            title: "Admin Dashboard",
            stats: "Overview",
            bookings: "Bookings",
            contacts: "Messages",
            total: "Total Bookings",
            pending: "Pending",
            completed: "Completed",
            customers: "Customers",
            messages: "Messages",
            news: "News",
            gallery: "Gallery",
            newTitle: "Title",
            newSummary: "Short summary",
            newBody: "Full article body",
            newCategory: "Category",
            newImage: "Image URL (optional)",
            addNews: "Publish news",
            addPhoto: "Add photo",
            caption: "Caption",
            chooseImage: "Choose image (JPG/PNG/WEBP)",
            updateStatus: "Update Status",
            reference: "Reference",
            service: "Service",
            customer: "Customer",
            phone: "Phone",
            status: "Status",
            date: "Date",
            actions: "Actions",
        },
        footer: {
            about: "About",
            aboutDesc: "Your trusted MeeSeva & multi-service center in Mahabubnagar.",
            quickLinks: "Quick Links",
            legal: "Legal",
            privacy: "Privacy Policy",
            terms: "Terms & Conditions",
            reach: "Reach Us",
            rights: "All rights reserved.",
        },
        common: {
            book: "Book Now",
            call: "Call",
            whatsapp: "WhatsApp",
            direction: "Get Directions",
            copy: "Copy",
            copied: "Copied!",
        },
    },
    te: {
        nav: {
            home: "హోమ్", about: "గురించి", services: "సర్వీసులు", booking: "బుక్ చేయండి",
            track: "ట్రాక్", gallery: "గ్యాలరీ", contact: "సంప్రదించండి", login: "కస్టమర్ లాగిన్",
            adminLogin: "అడ్మిన్", dashboard: "డాష్‌బోర్డ్", logout: "లాగ్ అవుట్", register: "నమోదు",
            forms: "ఫారంలు", news: "వార్తలు",
        },
        hero: {
            tagline: "మొదటి రోజు నుండి నమ్మకమైనవి",
            title1: "ప్రభుత్వ &",
            title2: "డిజిటల్ సర్వీసులు",
            title3: "సులభంగా",
            desc: "శ్రీ మాత మల్టీసర్వీసెస్ మహబూబ్‌నగర్‌లో అధీకృత మీ సేవ & మల్టీ-సర్వీస్ కేంద్రం — ఆధార్, పాన్, పాస్‌పోర్ట్, ధృవీకరణలు, చెల్లింపులు ఇంకా ఎన్నో సేవలు ఒకే చోట.",
            cta1: "సర్వీస్ బుక్ చేయండి",
            cta2: "అప్లికేషన్ ట్రాక్ చేయండి",
            stat1: "21+ సర్వీసులు",
            stat2: "5000+ కస్టమర్లు",
            stat3: "మీ సేవ అధీకృతం",
        },
        home: {
            servicesTitle: "మీకు కావలసినవన్నీ ఒకే సందర్శనలో",
            servicesDesc: "అవసరమైన ప్రభుత్వ IDల నుండి రోజువారీ యుటిలిటీ చెల్లింపుల వరకు.",
            viewAll: "అన్ని సర్వీసులు చూడండి",
            whyTitle: "శ్రీ మాత ఎందుకు?",
            whyDesc: "ప్రొఫెషనల్ సిస్టమ్స్‌తో స్థానిక నమ్మకమైన పేరు.",
            f1t: "అధీకృత కేంద్రం",
            f1d: "అధికారిక మీ సేవ ఫ్రాంచైజీ.",
            f2t: "వేగవంతమైన సేవ",
            f2d: "శిక్షణ పొందిన సిబ్బంది మరియు వర్క్‌ఫ్లోలు.",
            f3t: "ఎప్పుడైనా ట్రాక్",
            f3d: "రిఫరెన్స్ నంబర్‌తో 24×7 ట్రాకింగ్.",
            f4t: "సురక్షిత & ప్రైవేటు",
            f4d: "మీ డాక్యుమెంట్‌లు గోప్యంగా.",
            ctaTitle: "ప్రారంభించడానికి సిద్ధమా?",
            ctaDesc: "ఒక్క నిమిషంలో ఆన్‌లైన్‌లో బుక్ చేసుకోండి.",
            newsTitle: "తాజా నవీకరణలు",
            newsDesc: "కొత్త పథకాలు, నిబంధనలు మరియు మార్పుల గురించి తెలుసుకోండి.",
            viewAllNews: "అన్ని వార్తలు చూడండి",
        },
        about: {
            title: "శ్రీ మాత మల్టీసర్వీసెస్ గురించి",
            lead: "మహబూబ్‌నగర్‌కు అధీకృత మీ సేవ & మల్టీ-సర్వీస్ సొల్యూషన్స్.",
            body1: "సంవత్సరాలుగా, శ్రీ మాత మల్టీసర్వీసెస్ ప్రభుత్వ డాక్యుమెంటేషన్, డిజిటల్ చెల్లింపులు మరియు రోజువారీ సేవలు కోసం నమ్మకమైన గమ్యస్థానం. MBNR మెయిన్ రోడ్‌లో IOCL పెట్రోల్ పంప్ దగ్గర, జనంపేటలో ఉంది.",
            body2: "మేము మీ ప్రతి అడుగులో మార్గనిర్దేశం చేస్తాము. మీ టైలరింగ్ అవసరాలకు ప్రత్యేక ఎంబ్రాయిడరీ సేవలను కూడా అందిస్తాము.",
            mission: "మా మిషన్",
            missionDesc: "మహబూబ్‌నగర్‌లోని ప్రతి పౌరుడికి నమ్మకమైన సేవలు అందించడం.",
            values: "మా విలువలు",
            v1: "నమ్మకం", v2: "వేగం", v3: "పారదర్శకత", v4: "శ్రద్ధ",
        },
        services: { title: "మా సర్వీసులు", desc: "మా అన్ని సర్వీసులు.", searchPh: "సర్వీస్ వెతకండి…", book: "బుక్ చేయండి" },
        booking: {
            title: "ఆన్‌లైన్ బుకింగ్",
            desc: "ఫారమ్ పూరించండి. ట్రాకింగ్ కోసం రిఫరెన్స్ నంబర్ లభిస్తుంది.",
            step1: "సర్వీస్ ఎంచుకోండి", step2: "మీ వివరాలు", step3: "డాక్యుమెంట్లు", step4: "సబ్మిట్",
            service: "సర్వీస్", fullName: "పూర్తి పేరు", phone: "ఫోన్", email: "ఇమెయిల్",
            address: "చిరునామా", notes: "అవసరాలు",
            uploadTitle: "డాక్యుమెంట్లు అప్‌లోడ్ (ఐచ్ఛికం)",
            uploadDesc: "PDF, JPG, PNG 8MB వరకు.",
            submit: "సబ్మిట్",
            next: "కొనసాగించండి", back: "వెనుక",
            success: "బుకింగ్ విజయవంతం!",
            reference: "మీ రిఫరెన్స్ నంబర్",
        },
        track: {
            title: "మీ అప్లికేషన్ ట్రాక్ చేయండి",
            desc: "రిఫరెన్స్ నంబర్ ఇవ్వండి.",
            placeholder: "ఉదా. SMM250219ABC12",
            track: "ట్రాక్",
            status: "స్థితి",
            notFound: "ఈ రిఫరెన్స్‌తో అప్లికేషన్ కనుగొనబడలేదు.",
        },
        gallery: { title: "గ్యాలరీ", desc: "మా కేంద్రం మరియు సర్వీసుల చిత్రాలు." },
        news: {
            chip: "వార్తలు & నవీకరణలు",
            title: "తాజా వార్తలు & ప్రకటనలు",
            desc: "ప్రభుత్వ నోటీసులు, మీ సేవ నవీకరణలు మరియు సర్వీస్ హెచ్చరికలు — మీకోసం క్యూరేట్ చేసినవి.",
            empty: "ఇంకా వార్తలు లేవు. దయచేసి తర్వాత తనిఖీ చేయండి.",
            readMore: "మరింత చదవండి",
        },
        forms: {
            chip: "అప్లికేషన్ ఫారంలు",
            title: "అప్లికేషన్ ఫారంలు డౌన్‌లోడ్",
            desc: "సాధారణ సేవలకు అధికారిక ప్రభుత్వ ఫారంలు. డౌన్‌లోడ్ చేసుకుని, పూరించి మా కేంద్రానికి తీసుకురండి.",
            searchPh: "ఫారం వెతకండి…",
            download: "డౌన్‌లోడ్",
            needHelpTitle: "ఏ ఫారం అవసరమో తెలియలేదా?",
            needHelpDesc: "వాట్సాప్‌లో సందేశం పంపండి — మా బృందం సహాయం చేస్తుంది.",
        },
        contact: {
            title: "మమ్మల్ని సంప్రదించండి",
            desc: "మేము సహాయపడతాము.",
            name: "పేరు", email: "ఇమెయిల్", phone: "ఫోన్", subject: "సబ్జెక్టు", message: "మెసేజ్",
            send: "సందేశం పంపండి",
            sent: "సందేశం పంపబడింది!",
            visit: "సందర్శించండి", call: "కాల్ చేయండి", write: "వ్రాయండి", hours: "పని గంటలు",
            hoursValue: "సోమ – శని: ఉ. 9:00 – రా. 8:30\nఆది: ఉ. 10:00 – మ. 2:00",
        },
        auth: {
            loginTitle: "మళ్ళీ స్వాగతం",
            loginDesc: "మీ అప్లికేషన్‌లను ట్రాక్ చేయడానికి లాగిన్ అవ్వండి.",
            registerTitle: "ఖాతా సృష్టించండి",
            registerDesc: "ఉచితంగా నమోదు.",
            adminTitle: "అడ్మిన్ లాగిన్",
            adminDesc: "అడ్మిన్ మాత్రమే.",
            emailPh: "ఇమెయిల్",
            passwordPh: "పాస్‌వర్డ్",
            namePh: "పూర్తి పేరు",
            phonePh: "ఫోన్ నంబర్",
            login: "లాగిన్",
            register: "నమోదు",
            switchToRegister: "కొత్తవారా? ఖాతా సృష్టించండి",
            switchToLogin: "ఇప్పటికే ఖాతా ఉందా? లాగిన్",
            or: "లేదా",
        },
        dashboard: {
            welcome: "స్వాగతం",
            myBookings: "నా బుకింగ్‌లు",
            noBookings: "మీకు ఇంకా బుకింగ్‌లు లేవు.",
            bookNow: "బుక్ చేయండి",
        },
        admin: {
            title: "అడ్మిన్ డాష్‌బోర్డ్",
            stats: "సారాంశం", bookings: "బుకింగ్‌లు", contacts: "సందేశాలు",
            total: "మొత్తం", pending: "పెండింగ్", completed: "పూర్తయినవి",
            customers: "కస్టమర్లు", messages: "సందేశాలు",
            news: "వార్తలు",
            gallery: "గ్యాలరీ",
            newTitle: "శీర్షిక",
            newSummary: "సంక్షిప్త సారాంశం",
            newBody: "పూర్తి కథనం",
            newCategory: "వర్గం",
            newImage: "చిత్రం URL (ఐచ్ఛికం)",
            addNews: "వార్త ప్రచురించండి",
            addPhoto: "ఫోటో జోడించండి",
            caption: "క్యాప్షన్",
            chooseImage: "చిత్రం ఎంచుకోండి (JPG/PNG/WEBP)",
            updateStatus: "స్థితి అప్‌డేట్",
            reference: "రిఫరెన్స్", service: "సర్వీస్", customer: "కస్టమర్",
            phone: "ఫోన్", status: "స్థితి", date: "తేదీ", actions: "చర్యలు",
        },
        footer: {
            about: "గురించి",
            aboutDesc: "మహబూబ్‌నగర్‌లో మీ నమ్మకమైన మీ సేవ & మల్టీ-సర్వీస్.",
            quickLinks: "క్విక్ లింక్స్",
            legal: "చట్టపరమైన",
            privacy: "గోప్యతా విధానం",
            terms: "నిబంధనలు",
            reach: "మమ్మల్ని చేరుకోండి",
            rights: "అన్ని హక్కులు రిజర్వ్డ్.",
        },
        common: { book: "బుక్ చేయండి", call: "కాల్", whatsapp: "వాట్సాప్", direction: "మార్గం", copy: "కాపీ", copied: "కాపీ అయింది!" },
    },
};
